"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DropdownContent_component_exports = {};
__export(DropdownContent_component_exports, {
  DropdownContent: () => DropdownContent
});
module.exports = __toCommonJS(DropdownContent_component_exports);
var import_react = __toESM(require("react"));
var import_keyBy = __toESM(require("lodash/keyBy"));
var import_atoms = require("../../atoms");
var import_useOnBlur = require("../../../utils/useOnBlur/useOnBlur.hook");
var import_useOnClickOutside = require("../../../utils/useOnClickOutside/useOnClickOutside.hook");
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_DropdownContent = require("./DropdownContent.styled");
var _excluded = ["itemType", "ariaLabel", "listMode", "closeList", "placement", "showOptionSeparators", "navigateThroughListOptionsUsingTabKey", "multiSelect", "countSelectedItems", "tabTrapFocus"];
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r))
    return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var DropdownContent = function DropdownContent2(_ref) {
  var _ref$itemType = _ref.itemType, itemType = _ref$itemType === void 0 ? "button" : _ref$itemType, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "" : _ref$ariaLabel, _ref$listMode = _ref.listMode, listMode = _ref$listMode === void 0 ? false : _ref$listMode, _ref$closeList = _ref.closeList, closeList = _ref$closeList === void 0 ? false : _ref$closeList, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$showOptionSepara = _ref.showOptionSeparators, showOptionSeparators = _ref$showOptionSepara === void 0 ? false : _ref$showOptionSepara, _ref$navigateThroughL = _ref.navigateThroughListOptionsUsingTabKey, navigateThroughListOptionsUsingTabKey = _ref$navigateThroughL === void 0 ? true : _ref$navigateThroughL, _ref$multiSelect = _ref.multiSelect, multiSelect = _ref$multiSelect === void 0 ? false : _ref$multiSelect, _ref$countSelectedIte = _ref.countSelectedItems, countSelectedItems = _ref$countSelectedIte === void 0 ? false : _ref$countSelectedIte, _ref$tabTrapFocus = _ref.tabTrapFocus, tabTrapFocus = _ref$tabTrapFocus === void 0 ? false : _ref$tabTrapFocus, props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, import_react.useState)([]), _useState2 = _slicedToArray(_useState, 2), selectedValues = _useState2[0], setSelectedValues = _useState2[1];
  var _useState3 = (0, import_react.useState)([]), _useState4 = _slicedToArray(_useState3, 2), selectedIds = _useState4[0], setSelectedIds = _useState4[1];
  var _useState5 = (0, import_react.useState)(false), _useState6 = _slicedToArray(_useState5, 2), listOpened = _useState6[0], setListOpened = _useState6[1];
  var _useState7 = (0, import_react.useState)(), _useState8 = _slicedToArray(_useState7, 2), focusedOption = _useState8[0], setFocusedOption = _useState8[1];
  var activatorRef = (0, import_react.useRef)(null);
  var wrapperRef = (0, import_react.useRef)(null);
  var Wrapper = function Wrapper2(_ref2) {
    var children = _ref2.children, condition = _ref2.condition, wrapper = _ref2.wrapper;
    return condition ? wrapper(children) : children;
  };
  var list = props.list;
  (0, import_useOnClickOutside.useOnClickOutside)(wrapperRef, function() {
    setListOpened(false);
  });
  (0, import_useOnBlur.useOnBlur)(wrapperRef, function() {
    setTimeout(function() {
      setListOpened(false);
    }, 200);
  });
  var focusOnSelected = function focusOnSelected2() {
    var firstValidElementAvailable = list.find(function(el) {
      return !el.disabled;
    });
    var firstValidElementIndexAvailable = list.indexOf(firstValidElementAvailable);
    if (selectedIds.length > 0) {
      var selectedIndex = list.find(function(el) {
        return selectedIds.includes(el.id);
      });
      var firstValidElementIndex = list.indexOf(selectedIndex);
      setFocusedOption(firstValidElementIndex);
    } else {
      setFocusedOption(firstValidElementIndexAvailable);
    }
  };
  var toggleList = function toggleList2() {
    setListOpened(!listOpened);
    focusOnSelected();
  };
  var selectItem = function selectItem2(id) {
    if (props.toggleItem)
      props.toggleItem(id);
    if (!props.disableListSelection) {
      var selectedOption = list.find(function(item) {
        return item.id === id;
      });
      if (multiSelect) {
        setSelectedValues([].concat(_toConsumableArray(selectedValues), [selectedOption.children || selectedOption.name]));
        setSelectedIds([].concat(_toConsumableArray(selectedIds), [id]));
      } else {
        setSelectedValues([selectedOption.children || selectedOption.name]);
        setSelectedIds([id]);
        setListOpened(false);
        activatorRef.current.focus();
      }
    }
    for (var i = 0; i < list.length; i += 1) {
      if (list[i].handleOnSelect && id === list[i].id) {
        list[i].handleOnSelect(id);
      }
    }
  };
  var deselectItem = function deselectItem2(id) {
    var filteredItems = list.filter(function(item) {
      return selectedIds.includes(item.id) && item.id !== id;
    });
    var filteredIds = filteredItems.map(function(item) {
      return item.id;
    });
    var filteredValues = filteredItems.map(function(item) {
      return item.children || item.name;
    });
    setSelectedIds(filteredIds);
    setSelectedValues(filteredValues);
    var unselectedItem = props.list.find(function(_ref3) {
      var itemId = _ref3.id;
      return itemId === id;
    });
    if (unselectedItem.handleOnUnselect)
      unselectedItem.handleOnUnselect(id);
  };
  var onOptionClick = function onOptionClick2(id) {
    if (multiSelect) {
      var currentItem = list.findIndex(function(item) {
        return item.id === id;
      });
      setFocusedOption(currentItem);
      if (selectedIds.includes(id)) {
        deselectItem(id);
      } else {
        selectItem(id);
      }
    } else {
      selectItem(id);
      focusOnSelected();
    }
  };
  (0, import_react.useEffect)(function() {
    if (listOpened) {
      var buttons = wrapperRef.current.querySelectorAll("button[id], a[id]");
      if (typeof focusedOption === "number" && buttons[focusedOption]) {
        setTimeout(function() {
          buttons[focusedOption].focus();
        }, 0);
      }
    }
  }, [listOpened]);
  (0, import_react.useEffect)(function() {
    if (countSelectedItems && multiSelect) {
      var filteredItems = list.filter(function(_ref4) {
        var isSelected = _ref4.isSelected;
        return isSelected;
      });
      setSelectedIds(filteredItems.map(function(_ref5) {
        var id = _ref5.id;
        return id;
      }));
      setSelectedValues(filteredItems.map(function(_ref6) {
        var children = _ref6.children, name = _ref6.name;
        return children || name;
      }));
    }
  }, [list, countSelectedItems, multiSelect]);
  (0, import_react.useEffect)(function() {
    if (props.selectedItem) {
      setSelectedIds([props.selectedItem.id]);
      setSelectedValues([props.selectedItem.children || props.selectedItem.name]);
    }
    if (props.listOpenHandler) {
      setListOpened(props.listOpenHandler);
    }
    if (closeList) {
      setListOpened(false);
    }
  }, [props.selectedItem, closeList, props.listOpenHandler]);
  (0, import_useOnKeydown.useOnKeydown)(wrapperRef, function(keyList, event) {
    var ArrowDown = keyList.ArrowDown, ArrowUp = keyList.ArrowUp, ArrowRight = keyList.ArrowRight, ArrowLeft = keyList.ArrowLeft, Escape = keyList.Escape, Enter = keyList.Enter, End = keyList.End, Home = keyList.Home, Space = keyList[" "];
    var buttons = wrapperRef.current.querySelectorAll("button[id], a[id]");
    var buttonsId = Object.keys((0, import_keyBy.default)(buttons, "id"));
    var activeItem = document.activeElement;
    var currentPosition = buttonsId.indexOf(activeItem.id);
    var dropItemsSize = buttons.length - 1;
    var input = wrapperRef.current.querySelector('input[type="text"]');
    var firstValidElementAvailable = list.find(function(el) {
      return !el.disabled;
    });
    var firstValidElementIndexAvailable = list.indexOf(firstValidElementAvailable);
    var reversedItems = list.map(function(item) {
      return item;
    }).reverse();
    var lastValidElement = reversedItems.find(function(el) {
      return !el.disabled;
    });
    var lastValidElementIndex = list.indexOf(lastValidElement);
    var enterOrSpace = function enterOrSpace2() {
      setListOpened(true);
      event.preventDefault();
      focusOnSelected();
    };
    if (Enter && event.target === activatorRef.current) {
      enterOrSpace();
    }
    if (Space) {
      enterOrSpace();
      event.preventDefault();
    }
    if (Home) {
      event.preventDefault();
      if (input) {
        input.focus();
        input.setSelectionRange(0, 0);
      }
      if (listOpened) {
        event.stopPropagation();
        var itemId = firstValidElementAvailable.id;
        if (multiSelect) {
          if (selectedIds.includes(itemId)) {
            deselectItem(itemId);
          } else {
            selectItem(itemId);
          }
        } else {
          selectItem(itemId);
        }
        setListOpened(true);
        setFocusedOption(firstValidElementIndexAvailable);
      }
    }
    if (End) {
      event.preventDefault();
      if (input) {
        var pos = input.value.length;
        input.focus();
        input.setSelectionRange(pos, pos);
      }
      if (listOpened) {
        event.stopPropagation();
        var _itemId = lastValidElement.id;
        if (multiSelect) {
          if (selectedIds.includes(_itemId)) {
            deselectItem(_itemId);
          } else {
            selectItem(_itemId);
          }
        } else {
          selectItem(_itemId);
        }
        setListOpened(true);
        setFocusedOption(lastValidElementIndex);
      }
    }
    if (ArrowUp) {
      if (!listOpened && list.length > 0) {
        enterOrSpace();
        if (selectedIds.length < 1) {
          setFocusedOption(lastValidElementIndex);
        }
      } else {
        var _pos = currentPosition <= 0 ? dropItemsSize : currentPosition - 1;
        if (buttons[_pos]) {
          buttons[_pos].focus();
        }
      }
    }
    if (ArrowDown) {
      if (!listOpened && list.length > 0) {
        enterOrSpace();
      } else {
        var _pos2 = [dropItemsSize, -1].includes(currentPosition) ? 0 : currentPosition + 1;
        if (buttons[_pos2]) {
          buttons[_pos2].focus();
        }
      }
    }
    if ((ArrowRight || ArrowLeft) && input) {
      input.focus();
    }
    if (Escape) {
      setListOpened(false);
      if (input) {
        if (!multiSelect) {
          setSelectedValues([]);
          setSelectedIds([]);
        }
        input.focus();
      } else {
        activatorRef.current.focus();
      }
    }
  });
  var getItemAriaLabel = function getItemAriaLabel2(item) {
    if (!item.ariaLabelItem) {
      return void 0;
    }
    var itemAriaLabel = listMode ? item.ariaLabelItem : item.id;
    if (selectedIds.includes(item.id)) {
      return "Selected option ".concat(itemAriaLabel);
    }
    return itemAriaLabel;
  };
  var getSelectedValue = function getSelectedValue2() {
    if (multiSelect) {
      return selectedIds.length !== 0 || !props.placeholder ? "".concat(selectedIds.length, " Selected") : void 0;
    }
    return selectedValues[0];
  };
  return /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledDropdownContentWrapper, {
    "data-testid": "wrapper",
    className: props.className,
    id: props.id,
    ref: wrapperRef
  }, props.activator({
    activatorRef,
    isDisabled: props.disabled,
    listOpened,
    selectedValue: getSelectedValue(),
    toggleList
  }), listOpened && !props.disabled && /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledPopover, {
    "aria-activedescendant": selectedIds[0],
    isOpen: true,
    maxHeight: props.maxHeight,
    offset: props.offset,
    placement,
    referenceElem: activatorRef,
    width: props.width,
    "aria-label": listMode ? ariaLabel : "App List",
    role: listMode ? "group" : "listbox",
    customPosition: props.customPositionOfPopover,
    hasArrow: false,
    tabTrapFocus: !tabTrapFocus
  }, /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledNav, null, /* @__PURE__ */ import_react.default.createElement(Wrapper, {
    condition: listMode,
    wrapper: function wrapper(children) {
      return /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledListContainer, {
        role: "list",
        "aria-label": ariaLabel
      }, children);
    }
  }, /* @__PURE__ */ import_react.default.createElement(Wrapper, {
    condition: !listMode,
    wrapper: function wrapper(children) {
      return /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledDropdownContainer, {
        className: "dropdown-container"
      }, children);
    }
  }, props.list.map(function(item) {
    return /* @__PURE__ */ import_react.default.createElement(import_atoms.DropdownItem, {
      key: item.id,
      id: item.id,
      type: itemType,
      href: item.href,
      disabled: item.disabled,
      isSelected: selectedIds.includes(item.id),
      handleOnSelect: onOptionClick,
      ariaLabelItem: getItemAriaLabel(item),
      dataDpAnalyticsId: item.dataDpAnalyticsId,
      role: props.dropdownItemAriaRole ? props.dropdownItemAriaRole : listMode ? "" : "option",
      listMode,
      WrapperComponent: item.WrapperComponent,
      showOptionSeparators,
      tabIndex: navigateThroughListOptionsUsingTabKey ? 0 : -1,
      disableListSelection: props.disableListSelection
    }, multiSelect ? /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledOptionCheckBox, {
      tabIndex: -1,
      isChecked: selectedIds.includes(item.id),
      "aria-label": "Checkbox option ".concat(selectedIds.includes(item.id) ? "selected" : "")
    }) : (item.icon || props.optionsIcon) && /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledItemIcon, {
      icon: item.icon || props.optionsIcon,
      "aria-hidden": true
    }), /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledItemTextContainer, null, (item.minorTitle || props.optionsMinorTitle) && /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledMinorTitle, null, item.minorTitle || props.optionsMinorTitle), item.tooltipText ? /* @__PURE__ */ import_react.default.createElement(import_atoms.Tooltip, {
      value: item.tooltipText,
      placement: "top-end",
      offset: [100, 0],
      customizedHeight: "auto",
      includeScreenReaderOnlyText: true
    }, /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledOptionText, {
      "data-testid": "dropdown-option-text",
      optionsOverflow: props.optionsOverflow
    }, item.name || item.description || item.children)) : /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledOptionText, {
      "data-testid": "dropdown-option-text",
      optionsOverflow: props.optionsOverflow
    }, item.name || item.description || item.children)), !multiSelect && selectedIds.includes(item.id) && /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledCheckIcon, {
      icon: "check"
    }));
  }))))), (props.hintText || props.errorText) && /* @__PURE__ */ import_react.default.createElement(import_atoms.Tooltip, {
    value: props.errorText || props.hintText
  }, /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledHelperText, {
    width: props.width,
    errorMode: props.errorMode,
    darkMode: props.darkMode
  }, props.errorText && !props.disabled && /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledIcon, {
    ariaHidden: true,
    icon: "warning",
    size: "l"
  }), props.hintText && props.hintIcon && !props.errorMode && /* @__PURE__ */ import_react.default.createElement(import_DropdownContent.StyledIcon, {
    ariaHidden: true,
    icon: props.hintIcon,
    size: "l"
  }), props.errorText && !props.disabled && /* @__PURE__ */ import_react.default.createElement("span", null, props.errorText), props.hintText && !props.errorMode && /* @__PURE__ */ import_react.default.createElement("span", null, props.hintText))));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DropdownContent
});
//# sourceMappingURL=DropdownContent.component.js.map